<template>

      <el-row type="flex" justify="space-start" :gutter="20">
        <el-col :span="12">
  
            <div class="card-header">
              <h4 class="card-title">Import Customers</h4>
            </div>
            <el-upload
              class="upload-demo"
              label="Avatar"
              ref="upload"
              :headers="headerInfo"
              :show-file-list="false"
              :http-request="upload"
              :auto-upload="true"
              :multiple="false"
              :file-list="files"
              action="#"
            >
              <el-button slot="trigger" size="small" type="primary">select file</el-button>

              <div class="el-upload__tip" slot="tip">csv files with a size less than 500kb</div>
            </el-upload>
            <el-progress
              v-if="processing && percentage!==100"
              :text-inside="true"
              :stroke-width="26"
              :percentage="percentage"
            ></el-progress>
            
            <el-alert
              v-if="percentage==100"
              title="file succesfully  uploaded, now doing enrollments..."
              type="success"
               show-icon
               :closable="true"
            ></el-alert>
           
            <el-alert v-if="enrollmentSuccess" title="Enrollments complete" type="success"  show-icon :closable="true"></el-alert>
            <el-alert v-if="error" title="Enrollments error" :description="JSON.stringify(error)" type="error"></el-alert>
     
        </el-col>
      </el-row>

</template>
<script>
import httpClient from "../../httpClient";
import axios from 'axios'
export default {
  data() {
    return {
      processing: false,
      percentage: 0,
      error:null,
      enrollmentSuccess: false,
      files: [],
      imageUrl: "",
      uploadData: {
        dataType: "0",
        oldFilePath: ""
      },
      headerInfo: {
        "x-path": "avatars/",
        authorization: "Bearer " + window.localStorage.getItem("jwt_token")
      }
    };
  },
  methods: {
    submitUpload() {
      this.$refs.upload.submit();
    },
    async getPresignedPostData(selectedFile) {
     console.log('getting presigned url for the upload')
   return await httpClient.post(process.env.SERVERLESS_URL + "/customer/import",
          {partner:'meddeas',
            name: selectedFile.name,
            type: selectedFile.type
          }
        )  .then(function (res) {
            return res
            })
            .catch(function (err) {
      console.log(err)
            });
    
    },
  
   async uploadFileToS3(presignedPostData, file) {
  console.log(file)
        this.processing = true;
        const formData = new FormData();
         // formData.append("file", file)
        Object.keys(presignedPostData.fields).forEach(key => {
          
          formData.append(key, presignedPostData.fields[key]);
        });
          formData.append("file", file)
         const config = {
        onUploadProgress: function(progressEvent) {
          this.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(this.percentage)
        }.bind(this)
      };
      //can't post the auth header to aws so create new axios instance without the header
      const hClient = axios.create({});
 return await hClient.post(presignedPostData.url,formData,config).then(function (res) {
            return res
            })
            .catch(function (err) {
              this.error=err
      console.log(err)
            });
   
     
    },
    async parsefile(file) {
      console.log('file',file)
          const config = {
        onUploadProgress: function(progressEvent) {
          this.percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          console.log(this.percentage)
        }.bind(this)
      };
      return await httpClient.post(process.env.SERVERLESS_URL + "/customer/process", {partner:'meddeas',file:file.name})
     
      
    },
    async upload(selectedFile) {
      this.enrollmentSuccess=false;
       this.processing= false,
      console.log(selectedFile);
      const presignedPostData = await this.getPresignedPostData(
        selectedFile.file
      );
    
    
      try {
        await this.uploadFileToS3(
          presignedPostData.data.data,
          this.$refs.upload.uploadFiles[0].raw
        );
        console.log("File was successfully uploaded!");
        this.uploadSuccess = true;
       let doneEnrollments= await this.parsefile(selectedFile.file);
       console.log(doneEnrollments)
       if(doneEnrollments.request.status==200)
           this.enrollmentSuccess=true;
        
      } catch (err) {
        this.error=err
        console.log("An error occurred!", e.message);
      }
    }
  }
};
</script>
<style>
input[type="file"] {
  display: none;
}
</style>


// WEBPACK FOOTER //
// src/components/Customers/Import.vue